export default "__VITE_ASSET__0e9745d0__"